import { html } from "lit-html";
import { renderCssClasses } from "Helper/renderHelper/renderCssClasses";

export interface RenderIconArgs {
  iconId: string;
  cssClasses?: string;
}

export const renderIcon = (args: RenderIconArgs) => {
  return html`
    <sde-e-icon class="sde-e-icon ${renderCssClasses(args.cssClasses)}" icon-id="${args.iconId}"></sde-e-icon>
  `;
};
